import { cx } from "class-variance-authority";

import * as theme from "./ActivityTimeline.css";

export interface ActivityTimelineProps {
    children?: React.ReactNode;
    className?: string;
}

// Mostly a layout shell: it stacks ActivityTimelineItem children and lets each
// item draw its own connecting rail. The continuous line is achieved by the
// items themselves via :first-child / :last-child, so keep items as direct
// children (no wrappers in between).
export function ActivityTimeline({
    children,
    className,
}: ActivityTimelineProps) {
    return <div className={cx(theme.root, className)}>{children}</div>;
}
